import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { OLD_URL_REDIRECTS } from "./data/site";
import { RequestModalProvider } from "./components/RequestModal";
import AnalyticsTracker from "./components/AnalyticsTracker";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MobileBottomBar from "./components/MobileBottomBar";
import Home from "./pages/Home";
import RollOff from "./pages/RollOff";
import SizeGuide from "./pages/SizeGuide";
import Contractors from "./pages/Contractors";
import FrontLoadHub from "./pages/FrontLoadHub";
import FrontLoadService from "./pages/FrontLoadService";
import ServiceAreas from "./pages/ServiceAreas";
import ServiceAreaCity from "./pages/ServiceAreaCity";
import Resources from "./pages/Resources";
import ResourceArticle from "./pages/ResourceArticle";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import RequestDumpster from "./pages/RequestDumpster";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const PAGE_ROUTES = [
  ["/", <Home />],
  ["/roll-off-dumpsters", <RollOff />],
  ["/dumpster-size-guide", <SizeGuide />],
  ["/contractor-dumpster-rentals", <Contractors />],
  ["/front-load", <FrontLoadHub />],
  ["/front-load/residential", <FrontLoadService kind="residential" />],
  ["/front-load/commercial", <FrontLoadService kind="commercial" />],
  ["/service-areas", <ServiceAreas />],
  ["/service-areas/:slug", <ServiceAreaCity />],
  ["/resources", <Resources />],
  ["/resources/:slug", <ResourceArticle />],
  ["/about", <About />],
  ["/gallery", <Gallery />],
  ["/contact", <Contact />],
  ["/request-a-dumpster", <RequestDumpster />],
];

function SiteLayout() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
    );
  }
  return (
    <RequestModalProvider>
      <Header />
      <main id="main-content">
        <Routes>
          {PAGE_ROUTES.map(([path, el]) => (
            <Route key={path} path={path} element={el} />
          ))}
          {Object.entries(OLD_URL_REDIRECTS).map(([from, to]) => (
            <Route key={from} path={from} element={<Navigate to={to} replace />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <MobileBottomBar />
    </RequestModalProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AnalyticsTracker />
      <SiteLayout />
      <Toaster position="top-center" richColors={false} />
    </BrowserRouter>
  );
}
